import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#7719aa",
        secondary: "#c760ff",
        blue: "#23b9d7",
      },
    },
  },
});
